import { useEffect, useState } from "react";
import { CloseGreyIcon } from "../../../assets/icons"
import { ClientProfileModalInfoDTO } from "../../../models/user/user.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import { userService } from "../../../services/userService";
import Loader from "../../shared/Loader";
import { ToLocalDateString } from "../../../utils/dateFormater";
import { Switch } from "@mui/material";

interface UserInfoViewProps {
    id: string;
    onClose: () => void;
}

const UserInfoView: React.FC<UserInfoViewProps> = ({ id, onClose }) => {

    const [userInfo, setUserInfo] = useState<ClientProfileModalInfoDTO>();

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();


    useEffect(() => {
        fetchUserInfo();
    }, []);


    const fetchUserInfo = async () => {
        setLoading(true);
        try {
            const response = await userService.getClientProfileModalInfo(id);
            if (response.success && response.data) {
                setUserInfo(response.data);
            } else {
                notify("error", "Greška prilikom učitavanja informacija o korisniku");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja informacija o korisniku");
        } finally {
            setLoading(false);
        }
    }

    const handleDeactivateAccount = async () => {
        setLoading(true);
        try {
            const response = await userService.delete(id);
            if (response.success) {
                notify("success", "Nalog uspešno deaktiviran");
                onClose();
            } else {
                notify("error", "Greška prilikom deaktivacije naloga");
            }
        } catch (error) {
            notify("error", "Greška prilikom deaktivacije naloga");
        } finally {
            setLoading(false);
        }
    }

    const handleActivateAccount = async () => {
        setLoading(true);
        try {
            const response = await userService.restore(id);
            if (response.success) {
                notify("success", "Nalog uspešno aktiviran");
                onClose();
            } else {
                notify("error", "Greška prilikom aktivacije naloga");
            }
        } catch (error) {
            notify("error", "Greška prilikom aktivacije naloga");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loader />
    }

    if (!userInfo) {
        return <div>Korisnik nije pronađen</div>;
    }

    return (
        <section className="modal-section user-info">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">
                                    <strong className="bold-text-3">Informacije o korisniku</strong>
                                </div>
                                <div className="description-text">Dostupne informacije o korisniku i istorija aktivnosti</div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={onClose} />
                            </div>
                        </div>
                        <div className="modal-profile-image-div">
                            <img src={userInfo.imageUrl + "@lg.webp"} loading="lazy" sizes="100vw" alt="" className="modal-profile-image" />
                        </div>
                        <div>
                            <div className="fs-1-75rem align-center bold">{userInfo.fullName}</div>
                        </div>
                        <div className="modal-body-div">
                            <div className="modal-div-body-header">
                                <div className="modal-div-body-header-text">Kontakt informacije</div>
                            </div>
                            <div className="modal-div-body-info-list">
                                <div className="modal-div-body-info-div">
                                    <div className="modal-div-body-info-data">Email</div>
                                    <div className="modal-div-body-info-text">{userInfo.email}</div>
                                </div>
                                <div className="modal-div-body-info-div">
                                    <div className="modal-div-body-info-data">Telefon</div>
                                    <div className="modal-div-body-info-text">{userInfo.phoneNumber}</div>
                                </div>
                                <div className="modal-div-body-info-div">
                                    <div className="modal-div-body-info-data">Datum rodjenja</div>
                                    <div className="modal-div-body-info-text">{userInfo.birthDate ? ToLocalDateString(userInfo.birthDate.toString()) : "Nije naveden"}</div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body-div">
                            <div className="modal-div-body-header">
                                <div className="modal-div-body-header-text">Aktivnost</div>
                            </div>
                            <div className="div-block-99">
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.ordersCount}</div>
                                    <div className="description-text">Porudžbine</div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.totalSpent}</div>
                                    <div className="description-text">
                                        Potrošeno (RSD)<br />
                                    </div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.reservationsCount}</div>
                                    <div className="description-text">
                                        Rezervacije<br />
                                    </div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.ordersDineInCount}</div>
                                    <div className="description-text">Porudžbine - Dine In</div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.ordersPickupCount}</div>
                                    <div className="description-text">Porudžbine - Pick Up</div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.ordersDeliveryCount}</div>
                                    <div className="description-text">Porudžbine - Delivery</div>
                                </div>
                                <div className="div-block-98">
                                    <div className="fs-1-5rem bold">{userInfo.reportsCount}</div>
                                    <div className="description-text">Reports</div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-body-div">
                            <div className="modal-div-body-header">
                                <div className="modal-div-body-header-text">Datumi</div>
                            </div>
                            <div className="modal-div-body-info-list">
                                <div className="modal-div-body-info-div">
                                    <div className="modal-div-body-info-data">Registrovan</div>
                                    <div className="modal-div-body-info-text">{ToLocalDateString(userInfo.createdAt.toString())}</div>
                                </div>
                                {/* TO DO 
                                <div className="modal-div-body-info-div">
                                    <div className="modal-div-body-info-data">Poslednja prijava</div>
                                    <div className="modal-div-body-info-text">22.01.2026. 22:33</div>
                                </div> */}
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form" >
                                <div className="modal-form-div f-horizontal">
                                    <label className="modal-form-label">
                                        <strong>Aktivan Nalog*</strong>
                                        <br />
                                    </label>
                                    <Switch
                                        checked={userInfo.isActive}
                                    />
                                </div>
                            </form>
                        </div>

                        {userInfo.isActive ? (
                            <div className="modal-buttons">
                                <div className="button-secondary medium" onClick={onClose}>
                                    <div>Otkaži</div>
                                </div>
                                <div className="button-primary medium red-bg" onClick={handleDeactivateAccount}>
                                    <div>Deaktiviraj nalog</div>
                                </div>
                            </div>
                        ) : (
                            <div className="modal-buttons">
                                <div className="button-secondary medium" onClick={onClose}>
                                    <div>Otkaži</div>
                                </div>
                                <div className="button-primary medium green-bg" onClick={handleActivateAccount}>
                                    <div>Aktiviraj nalog</div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </section>
    )
}

export default UserInfoView;